import { useEffect, useRef } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { ChatList } from '../chatlist/ChatList'
import { repariereAbo } from '../../lib/push'
import { merkeOrt } from '../../lib/letzterChat'

/**
 * Zweispaltig am Rechner, einspaltig am Telefon.
 *
 * Welche Spalte auf dem Telefon zu sehen ist, entscheidet der Pfad: die
 * Startseite zeigt die Chatliste, jeder tiefere Pfad den geöffneten Inhalt.
 * Das ist bewusst nicht in einem Zustand gespeichert -- so bringt der
 * Zurück-Knopf des Browsers einen von selbst wieder zur Liste.
 */
export function Shell() {
  const location = useLocation()
  const pane = location.pathname === '/' ? 'list' : 'thread'

  // Einmal je Start: hat dieses Gerät seine Anmeldung für Benachrichtigungen
  // noch? Sie kann ohne Zutun verschwinden, und dann kommt einfach nichts
  // mehr -- ohne dass irgendwo etwas danach aussieht. Stillschweigend
  // wiederherstellen ist hier richtig: gefragt wurde schon, die Erlaubnis
  // liegt vor. Geht es nicht, bleibt es dabei; der Hinweis steht dann unter
  // Einstellungen.
  useEffect(() => {
    void repariereAbo().catch(() => undefined)
  }, [])

  // Wo man war, wird hier gemerkt und nicht in den Seiten selbst: hier kommt
  // jeder Weg vorbei, und `merkeOrt` nimmt ohnehin nur an, was zählt.
  //
  // **Die Übersicht ganz zu Beginn zählt nicht mit.** Sie ist keine
  // Entscheidung, sondern die Tür: mit ihr macht die Anwendung auf, wenn nicht
  // gerade eine Adresse mitgegeben wurde. Sie mitzuschreiben hieße, die
  // Erinnerung mit sich selbst zu überschreiben.
  //
  // Das ist nicht theoretisch. Die `StandWache` lädt beim ersten Start nach
  // einem Upload einmal neu — und auf diesem verworfenen ersten Durchgang
  // stünde sonst schon „Übersicht" im Speicher. Genau so kam auf dem iPhone
  // die Liste, obwohl zuletzt ein Chat offen war. Ein Chat als erster Weg
  // wird dagegen mitgeschrieben: den hat jemand mitgebracht.
  const ersterWeg = useRef(true)
  useEffect(() => {
    const erster = ersterWeg.current
    ersterWeg.current = false
    if (erster && location.pathname === '/') return
    merkeOrt(location.pathname)
  }, [location.pathname])

  return (
    <div className="shell" data-pane={pane}>
      <aside className="sidebar">
        <ChatList />
      </aside>
      <main className="main">
        <Outlet />
      </main>
    </div>
  )
}

